import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../sagas'
import cardsSlice from './slice/cardsSlice'
import prePaymentSlice from './slice/prePaymentSlice'
import transactionDetailsSlice from './slice/transactionDetailsSlice'
import pageStateSlice from './slice/pageStateSlice'
import paymentResponseSlice from './slice/paymentResponseSlice'
import cardinalCruiseSlice from './slice/cardinalCruiseSlice'
import paymentSlice from './slice/paymentSlice'
import payPalStylesSlice from './slice/payPalStylesSlice'
import billingAddressSlice from './slice/billingAddressSlice'

const sagaMiddleWare = createSagaMiddleware()

export default configureStore({
  reducer: {
    pageState: pageStateSlice,
    transactionDetails: transactionDetailsSlice,
    cards: cardsSlice,
    paymentResponse: paymentResponseSlice,
    cardinalCruise: cardinalCruiseSlice,
    payment: paymentSlice,
    paypalStyles: payPalStylesSlice,
    billingAddress: billingAddressSlice,
    prePayment: prePaymentSlice,
  },
  // preloadedState,
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }),
    sagaMiddleWare,
  ],
})

sagaMiddleWare.run(rootSaga)
